import { useEffect, useState } from "react";

const MINUTE = 60 * 1000;

// 다음 분 정각까지 남은 시간(ms)
const getDelayToNextMinute = () => MINUTE - (Date.now() % MINUTE);

// 현재 시각을 매 분 정각에 맞춰 갱신하는 훅
// - 다음 정각까지의 지연을 매번 실제 시각으로 다시 계산하므로 타이머가 늦게 실행되어도 오차가 쌓이지 않는다.
// - 탭이 숨겨졌다 다시 보이면(화면보호기 해제 등) 즉시 갱신한다. (숨김 상태에서는 브라우저가 타이머를 지연시킴)
const useMinuteClock = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const tick = () => {
      setNow(new Date());
      timeoutId = setTimeout(tick, getDelayToNextMinute());
    };

    const handleVisibilityChange = () => {
      if (document.hidden) return;
      clearTimeout(timeoutId);
      tick();
    };

    timeoutId = setTimeout(tick, getDelayToNextMinute());
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return now;
};

export default useMinuteClock;
